module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQzOC42IDcyOC45bDE5NC4zLTE5NC4yYTMyIDMyIDAgMCAwIDAtNDUuM2wtMTk0LjItMTk0LjNBMzIgMzIgMCAwIDAgMzg0IDMxNy43VjcwNi4yYTMyIDMyIDAgMCAwIDU0LjYgMjIuNnoiIGZpbGw9IiMwIiBwLWlkPSIzNDAzIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret right-filled.svg
// module id = CPZn
// module chunks = 75